import type { AEMOptions } from "@AEM/models/AEMPage.model"
import { AEMPageType } from "@AEM/models/AEMPage.model"
import type { AEMDictionary } from "@AEM/models/AEMResponse.model"
import type { UseQueryResult } from "@tanstack/react-query"
import { useAEMContent } from "./useAEMContent"

export enum AEM_DICTIONARY_COLLECTIONS {
	REGISTRATION = "registration",
	APPLICATION = "application"
}

export const useAEMDictionary = (
	collectionName?: AEM_DICTIONARY_COLLECTIONS
) => {
	const queryParams = collectionName
		? ({ queryParams: { name: collectionName } } as AEMOptions)
		: undefined
	const { data, isLoading, error, refetch } = useAEMContent(
		AEMPageType.DICTIONARY,
		{ ...queryParams }
	) as UseQueryResult<AEMDictionary>
	const dictionary = data

	return { dictionary, isLoading, error, refetch }
}
